<template>
  <div>
    <div class="exhibitorInquiry">
      <div class="title">
        <span>当前位置：&nbsp</span>
        <span>展会</span>
        <span>></span>
        <span>展商中心</span>
        <span style="margin: 0 9px;">></span>
        <span>展位图</span>
      </div>
      <div class="content">
        <div class="contentDiv" v-html="content"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["dataList"],
  components: {},
  data() {
    return {
      content: "",
    };
  },
  mounted() {
    this.$http({
      url: "getInformationList",
      method: "post",
      params: {
        type: "6",
      },
    })
      .then(({ data }) => {
        let { code, informationByTypeList } = data;
        if (code === 0 && informationByTypeList.length > 0) {
          this.content = informationByTypeList[0].content.replace(/<img/g, "<img style='max-width: 100%;height: auto; crossOrigin; display: block; margin: 0 auto;' ");
        }
      })
      .catch((err) => console.log(err));
  },
  methods: {
    detail(id) {
      // this.eventId = id;
    },
  },
};
</script>
<style lang="scss">
.exhibitorInquiry {
}
</style>
<style lang="scss" scoped>
.exhibitorInquiry {
  min-height: 1177px;
  background-color: #ffffff;
  box-shadow: -8px 0px 8px #fafafa, 0px -8px 8px #fafafa, 0px 8px 8px #fafafa;
  margin-bottom: 45px;
  .title {
    height: 43px;
    border-bottom: 1px solid #e5e5e5;
    line-height: 43px;
    padding-left: 17px;
    color: #b6b6b6;
    font-size: 12px;
    span:nth-child(3) {
      margin: 0 9px;
    }
  }
  .content {
    width: 857px;
    min-height: 958px;
    margin: 10px auto 21px;
    .contentDiv {
      width: 785px;
      min-height: 590px;
      margin: 40px auto 0;
    }
  }
}
</style>